import type { ArticleV1 } from 'types/capi/article';

import Pill from '~/components/Pill';

const Tags = ({ tags }: { tags: ArticleV1['tags'] }) => {
  if (!tags.length) return null;

  return (
    <div className="flex flex-wrap items-center justify-center gap-2">
      {tags.map((tag) => (
        <Pill key={tag.path} to={tag.path}>
          {tag.label}
        </Pill>
      ))}
    </div>
  );
};

export default Tags;
